import React from "react";
import { Button, Col, FormLabel, Row, Table } from "react-bootstrap";
import { AppContext } from "../AppContext.js";
import { PageListBean } from "../ds/client_ds.js";
import {
  BankAdjustmentReasonBean,
  BankAdjustmentReasonSearchCriteria,
  RestBankAdjustmentReasonListRequest,
  RestReadRequest,
} from "../ds/ds.js";
import { DeleteIcon, DropDwnDown, DropDwnUp } from "../gui_components/Icons.js";
import {
  AlertToolBox,
  InputCheckbox,
  InputTextbox,
  ShowError,
} from "../gui_components/UIComponents.js";
import { isEmptyArray } from "../gui_components/Util.js";
import {
  BaseInquiryPageListToolBar,
  BaseInquiryToolBar,
  BaseToolBar,
} from "../modules/BaseModule.js";
import { SecurityAccessManager } from "../security/SecurityAccessManager.js";
import { MasterService } from "../services/MasterService.js";
class BankAdjustmentReasonListForm extends React.Component {
  constructor(props) {
    super(props);
    this.listFormCodeRef = React.createRef();
  }
  componentDidMount() {}
  componentDidUpdate() {
    this.setInputFocus();
  }
  setInputFocus() {
    if (this.listFormCodeRef.current != null) {
      this.listFormCodeRef.current.focus();
    }
  }
  enterKeyEventHandler = (e) => {
    this.props.enterKeyEventHandler(e);
  };

  deleteOnClick = (e, val, rowData) => {
    if (e.detail == 1) this.props.deleteOnClick(val, rowData);
  };
  onChange = (e) => {
    this.props.onChange(e);
  };
  opentypeforms = (e) => {
    if (e.detail == 1) this.props.opentypeforms();
  };
  editBankAdjustmentReason = (e, info) => {
    if (e.detail == 1) this.props.editBankAdjustmentReason(info);
  };
  handleSortingChange = (e, accessor) => {
    if (e.detail == 1) this.props.handleSortingChange(accessor);
  };
  render() {
    let bankAdjustmentReason_list = this.props.bankAdjustmentReason_list;
    let bankAdjustmentReasonData = this.props.bankAdjustmentReasonData;

    return (
      <div>
        <div>
          <Row>
            <Col sm="2">
              <FormLabel id="searchBarLabel">Bank Adjustment Reason</FormLabel>
            </Col>
            <Col sm="2">
              <InputTextbox
                ref={this.listFormCodeRef}
                type="text"
                name="code"
                onChange={this.onChange}
                value={bankAdjustmentReasonData.code}
                style={{ "text-transform": "uppercase" }}
                enterKeyEventHandler={this.enterKeyEventHandler}
                isMandatory={true}
              ></InputTextbox>
            </Col>
            <Col sm="1">
              <Button
                id="fabric_Add_Button"
                className="text-center"
                onClick={(e) => this.opentypeforms(e)}
              >
                Go
              </Button>
            </Col>
          </Row>
        </div>

        <div className="div_default">
          <Table id="fabrics_tables_default">
            <thead>
              <tr>
                <th onClick={(e) => this.handleSortingChange(e, "code")}>
                  Code{" "}
                  {this.props.order === "desc" &&
                  this.props.sortField === "code" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th onClick={(e) => this.handleSortingChange(e, "description")}>
                  Name{" "}
                  {this.props.order === "desc" &&
                  this.props.sortField === "description" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th onClick={(e) => this.handleSortingChange(e, "companyCode")}>
                  CompanyCode{" "}
                  {this.props.order === "desc" &&
                  this.props.sortField === "companyCode" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th onClick={(e) => this.handleSortingChange(e, "isActive")}>
                  Active{" "}
                  {this.props.order === "desc" &&
                  this.props.sortField === "isActive" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th>Remove</th>
              </tr>
            </thead>
            <tbody>
              {bankAdjustmentReason_list.map((Info, index) => (
                <tr key={index}>
                  <td className="td_attribute_width">
                    <Button
                      variant="secondry"
                      className="hyperLinkText"
                      onClick={(e) =>
                        this.editBankAdjustmentReason(e, Info.code, Info)
                      }
                    >
                      {Info.code}
                    </Button>
                  </td>
                  <td> {Info.description}</td>
                  <td>{Info.companyCode}</td>
                  <td>{Info.isActive}</td>
                  <td className="text-right">
                    <Button
                      variant="secondry"
                      className="hyperLinkText"
                      onClick={(e) => this.deleteOnClick(e, Info.code, Info)}
                    >
                      {<DeleteIcon />}
                    </Button>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
          {bankAdjustmentReason_list.length != 0 ? null : (
            <div className="no_Data">{"NO DATA"}</div>
          )}
        </div>
      </div>
    );
  }
}

class BankAdjustmentReasonEntryForm extends React.Component {
  constructor(props) {
    super(props);
    this.codeRef = React.createRef();
  }

  componentDidMount() {
    this.setInputFocus();
  }
  setInputFocus() {
    if (this.codeRef.current != null) {
      this.codeRef.current.focus();
    }
  }
  onChange = (e) => {
    this.props.onChange(e);
  };

  render() {
    let bankAdjustmentReasonData = this.props.bankAdjustmentReasonData;
    let isDisableFields = this.props.isDisableFields;

    return (
      <div>
        <Row>
          <Col sm="1">
            {" "}
            <FormLabel>Company Code</FormLabel>{" "}
          </Col>
          <Col sm="2">
            {" "}
            <InputTextbox
              name="companyCode"
              type="text"
              placeholder="Enter CompanyCode"
              onChange={this.onChange}
              value={bankAdjustmentReasonData.companyCode}
              disabled={true}
            />{" "}
          </Col>
          <Col sm="1">
            {" "}
            <FormLabel>Code</FormLabel>{" "}
          </Col>
          <Col sm="2">
            {" "}
            <InputTextbox
              ref={this.codeRef}
              name="code"
              type="text"
              placeholder="Enter BankAdjustmentReasonCode"
              onChange={this.onChange}
              value={bankAdjustmentReasonData.code}
              style={{ "text-transform": "uppercase" }}
              disabled={isDisableFields}
              isMandatory={true}
            />{" "}
          </Col>
          <Col sm="1">
            <FormLabel>Name</FormLabel>{" "}
          </Col>
          <Col sm="2">
            <InputTextbox
              name="description"
              type="text"
              placeholder="Enter Name"
              onChange={this.onChange}
              value={bankAdjustmentReasonData.description}
              style={{ "text-transform": "capitalize" }}
              isMandatory={true}
            />
          </Col>
          <Col sm="1">
            <FormLabel>Active</FormLabel>
          </Col>
          <Col sm="1">
            {" "}
            <InputCheckbox
              type="checkbox"
              name="isActive"
              onChange={this.onChange}
              checked={bankAdjustmentReasonData.isActive}
            />
          </Col>
        </Row>
      </div>
    );
  }
}

class BankAdjustmentReasonList extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.state = {
      bankAdjustmentReason_list: [],
      response: {},
      pageTitle: "Bank Adjustment Reason",
      bankAdjustmentReasonData: new BankAdjustmentReasonBean(),
      pageList: new PageListBean(),
      criteria: new BankAdjustmentReasonSearchCriteria(),
      isShowSaveButton: false,
      isShowClearCriteriaButton: false,
      isShowClearErrorButton: false,
      isShowBackButton: false,
      error_list: [],
      currentPageNumber: 0,
      totalCount: 0,
      isBankAdjustmentReasonListFormOpen: true,
      isBankAdjustmentReasonEntryFormOpen: false,
      isShowNodes: false,
      selectedNode: "headerView",
      alertMessage: [],
      alertType: "",
      isShowAlert: false,
      isShowCode: false,
      isShowExitButton: true,
      isPageListToolBar: true,
      isLoadFirstButton: true,
      isLoadLastButton: true,
      isLoadPreviousButton: true,
      isLoadNextButton: true,
      isDisableFields: false,
      order: "asc",
      sortField: "",
    };
  }

  componentDidMount() {
    const { appData } = this.context;
    this.companyCode = appData.companyCode;
    let bankAdjustmentReasonData = new BankAdjustmentReasonBean();
    bankAdjustmentReasonData.companyCode = this.companyCode;
    this.setState({ bankAdjustmentReasonData: bankAdjustmentReasonData });
    this.loadPage(1);
    this.cleardata();
  }

  moduleCaption = "Bank Adjustment Reason";

  cleardata = () => {
    let bankAdjustmentReasonData = new BankAdjustmentReasonBean();
    bankAdjustmentReasonData.companyCode = this.companyCode;
    this.setState({ bankAdjustmentReasonData: bankAdjustmentReasonData });
  };
  saveBankAdjustmentReasonResponse = (response) => {
    this.handleresponse(response.data);
    this.loadPage(1);
    this.cleardata();
    this.closeBankAdjustmentReasonEntryForm();
  };

  saveBankAdjustmentReason = () => {
    let input = this.state.bankAdjustmentReasonData;
    if (input.isFetched == true) {
      if (
        SecurityAccessManager.BankAdjustmentReasonMaintenanceEdit_IsAccessible()
      ) {
        MasterService.updateBankAdjustmentReason(
          input,
          this.saveBankAdjustmentReasonResponse,
          this.errorCallBack
        );
      } else {
        let errMsg = "Access Denied";
        let errList = [];
        errList.push(errMsg);

        this.setState({
          alertMessage: errList,
          alertType: "danger",
          isShowAlert: true,
        });
      }
    } else {
      if (
        SecurityAccessManager.BankAdjustmentReasonMaintenanceCreate_IsAccessible()
      ) {
        MasterService.createBankAdjustmentReason(
          input,
          this.saveBankAdjustmentReasonResponse,
          this.errorCallBack
        );
      } else {
        let errMsg = "Access Denied";
        let errList = [];
        errList.push(errMsg);

        this.setState({
          alertMessage: errList,
          alertType: "danger",
          isShowAlert: true,
        });
      }
    }
  };
  disable = () => {
    this.setState({
      isDisableFields: true,
    });
  };

  editBankAdjustmentReasonResponse = (response) => {
    if (response.data != null) {
      if (response.data.bankAdjustmentReasonBean != null) {
        let bankAdjustmentReasonBean = response.data.bankAdjustmentReasonBean;
        this.setState({
          bankAdjustmentReasonData: bankAdjustmentReasonBean,
        });
        this.disable();
      }
      this.openBankAdjustmentReasonEntryForm();
    }
  };

  editBankAdjustmentReason = (code) => {
    let readrestInput = new RestReadRequest();
    readrestInput.companyCode = this.companyCode;
    readrestInput.code = code;
    if (
      SecurityAccessManager.BankAdjustmentReasonMaintenanceView_IsAccessible()
    ) {
      MasterService.readBankAdjustmentReason(
        readrestInput,
        this.editBankAdjustmentReasonResponse,
        this.errorCallBack
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };

  onChange = (e) => {
    let bankAdjustmentReasonData = this.state.bankAdjustmentReasonData;
    bankAdjustmentReasonData[e.target.name] = e.target.value;
    this.setState({
      bankAdjustmentReasonData: bankAdjustmentReasonData,
    });
  };
  deleteOnClick = (val, rowData) => {
    //
  };
  opentypeforms = () => {
    let bankAdjustmentReasonData = this.state.bankAdjustmentReasonData;
    this.editBankAdjustmentReason(bankAdjustmentReasonData.code);
  };
  enterKeyEventHandler = (e) => {
    e.preventDefault();
    setTimeout(() => {
      this.opentypeforms();
    }, 200);
  };

  handleresponse = (response) => {
    if (response.errors != null) {
      let errMsg = "";
      let errList = [];
      response.errors.map(
        (err) => (
          (errMsg = errMsg + err.messageDescription),
          errList.push(err.messageDescription)
        )
      );
      this.setState({ error_list: errList });

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }

    if (response.infos != null) {
      let infoMsg = "";
      let successList = [];
      response.infos.map(
        (info) => (
          (infoMsg = infoMsg + info.messageDescription),
          successList.push(info.messageDescription)
        )
      );
      this.setState({
        alertMessage: successList,
        alertType: "success",
        isShowAlert: true,
      });
    }
  };
  save = () => {
    this.saveBankAdjustmentReason();
  };

  back = () => {
    this.cleardata();
    this.cleardata();
    this.hideAlertCallBack(false);
    this.closeBankAdjustmentReasonEntryForm();
  };
  clearError = () => {
    this.setState({ error_list: [] });
  };
  openBankAdjustmentReasonEntryForm = () => {
    this.setState({
      isBankAdjustmentReasonListFormOpen: false,
      isBankAdjustmentReasonEntryFormOpen: true,
      isShowSaveButton: true,
      isShowClearCriteriaButton: false,
      isShowClearErrorButton: true,
      isShowBackButton: true,
      isShowNodes: false,
      isPageListToolBar: false,
      isLoadFirstButton: false,
      isLoadLastButton: false,
      isLoadPreviousButton: false,
      isLoadNextButton: false,
    });
    this.hideAlertCallBack();
  };

  closeBankAdjustmentReasonEntryForm = () => {
    this.clearError();
    let pageTitle = this.moduleCaption;
    this.setState({
      isBankAdjustmentReasonListFormOpen: true,
      isBankAdjustmentReasonEntryFormOpen: false,
      isShowSaveButton: false,
      isShowClearCriteriaButton: false,
      isShowBackButton: false,
      isShowClearErrorButton: false,
      pageTitle: pageTitle,
      isShowNodes: false,
      isPageListToolBar: true,
      isLoadFirstButton: true,
      isLoadLastButton: true,
      isLoadPreviousButton: true,
      isLoadNextButton: true,
      isDisableFields: false,
    });
  };

  moduleExit = () => {
    this.props.onModuleExit();
  };

  loadBankAdjustmentReasonResponse = (response) => {
    if (
      response.data != null &&
      response.data.bankAdjustmentReasonPageList != null
    ) {
      let bankAdjustmentReasons = new Array();
      if (
        !isEmptyArray(
          response.data.bankAdjustmentReasonPageList.bankAdjustmentReasons
        )
      ) {
        bankAdjustmentReasons =
          response.data.bankAdjustmentReasonPageList.bankAdjustmentReasons;
        bankAdjustmentReasons.map((Info) => {
          if (Info.isActive == true) {
            Info.isActive = "True";
          } else {
            Info.isActive = "False";
          }
        });
      }
      let pageList = this.state.pageList;
      pageList.totalCount =
        response.data.bankAdjustmentReasonPageList.totalCount;
      pageList.currentPage =
        response.data.bankAdjustmentReasonPageList.currentPage;
      pageList.pageSize = response.data.bankAdjustmentReasonPageList.pageSize;
      this.setState({
        bankAdjustmentReason_list: bankAdjustmentReasons,
        pageList: pageList,
      });
    }
  };
  loadFirst = () => {
    this.loadPage(1);
  };
  loadPrevious = () => {
    let currentPage = this.state.pageList.currentPage;
    let previousPage = currentPage - 1;
    this.loadPage(previousPage);
  };
  loadNext = () => {
    let currentPage = this.state.pageList.currentPage;
    let nextPage = currentPage + 1;
    this.loadPage(nextPage);
  };

  loadLast = () => {
    let pageSize = this.state.pageList.pageSize;
    let totalCount = this.state.pageList.totalCount;
    let totalPages = totalCount / pageSize;
    totalPages += totalCount % pageSize == 0 ? 0 : 1;
    this.loadPage(totalPages);
  };

  loadPage = (pageNumber) => {
    let criteria = new BankAdjustmentReasonSearchCriteria();
    criteria.companyCode = this.companyCode;
    let pageList = this.state.pageList;
    let pageInput = new PageListBean();
    pageInput.pageSize = 50;
    pageInput.currentPage = pageNumber;
    if (pageList != null) pageInput.totalCount = pageList.totalCount;
    this.state.pageList = pageInput;
    this.loadBankAdjustmentReasonPage(pageInput, criteria);
  };
  loadBankAdjustmentReasonPage = (pageList, searchCriteria) => {
    let requestInput = new RestBankAdjustmentReasonListRequest();
    requestInput.pageInput = pageList;
    requestInput.searchCriteria = searchCriteria;
    this.state.pageList = pageList;
    if (
      SecurityAccessManager.BankAdjustmentReasonMaintenanceView_IsAccessible()
    ) {
      MasterService.getBankAdjustmentReasonPageList(
        requestInput,
        this.loadBankAdjustmentReasonResponse,
        this.errorCallBack
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  errorCallBack = (error) => {
    ShowError("Error : " + error);
  };
  hideAlertCallBack = (msgType, isDisplayed) => {
    this.setState({ isShowAlert: isDisplayed, error_list: [] });
  };
  handleSortingChange = (accessor) => {
    let sortField = accessor;
    let order = this.state.order;
    let sortOrder = accessor === sortField && order === "asc" ? "desc" : "asc";
    this.setState({
      order: sortOrder,
      sortField: sortField,
    });
    this.handleSorting(sortField, sortOrder);
  };
  handleSorting = (sortField, sortOrder) => {
    let list = this.state.bankAdjustmentReason_list;
    if (sortField && !isEmptyArray(list)) {
      const sorted = [...list].sort((a, b) => {
        if (a[sortField] === null) return 1;
        if (b[sortField] === null) return -1;
        if (a[sortField] === null && b[sortField] === null) return 0;
        return (
          a[sortField].toString().localeCompare(b[sortField].toString(), "en", {
            numeric: true,
          }) * (sortOrder === "asc" ? 1 : -1)
        );
      });
      this.setState({ bankAdjustmentReason_list: sorted });
    }
  };
  render() {
    let pageList = this.state.pageList;
    let totalPages = 0;
    let pageSize = this.state.pageList.pageSize;
    let totalCount = this.state.pageList.totalCount;
    totalPages = totalCount / pageSize;
    totalPages += totalCount % pageSize == 0 ? 0 : 1;
    let currentPage = pageList.currentPage;
    return (
      <div>
        <AlertToolBox
          alertMsgList={this.state.alertMessage}
          alertErrorType={this.state.alertType}
          isShowAlert={this.state.isShowAlert}
          hideAlertCallBack={this.hideAlertCallBack}
        />
        {this.state.isPageListToolBar && (
          <BaseInquiryPageListToolBar
            currentPage={currentPage}
            totalPages={totalPages}
            isLoadFirstButton={this.state.isLoadFirstButton}
            isLoadLastButton={this.state.isLoadLastButton}
            isLoadPreviousButton={this.state.isLoadPreviousButton}
            isLoadNextButton={this.state.isLoadNextButton}
            loadFirst={this.loadFirst}
            loadLast={this.loadLast}
            loadNext={this.loadNext}
            loadPrevious={this.loadPrevious}
          />
        )}
        {this.state.isBankAdjustmentReasonListFormOpen && (
          <BaseInquiryToolBar
            onModuleExit={() => this.moduleExit()}
            pageTitle={this.state.pageTitle}
            isShowExitButton={this.state.isShowExitButton}
          />
        )}

        {!this.state.isBankAdjustmentReasonListFormOpen && (
          <BaseToolBar
            back={this.back}
            save={this.save}
            clearError={this.clearError}
            isShowSaveButton={this.state.isShowSaveButton}
            isShowClearCriteriaButton={this.state.isShowClearCriteriaButton}
            isShowClearErrorButton={this.state.isShowClearErrorButton}
            isShowBackButton={this.state.isShowBackButton}
            pageTitle={this.state.pageTitle}
          />
        )}
        {this.state.isBankAdjustmentReasonListFormOpen && (
          <BankAdjustmentReasonListForm
            {...this.state}
            onChange={this.onChange}
            editBankAdjustmentReason={this.editBankAdjustmentReason}
            enterKeyEventHandler={this.enterKeyEventHandler}
            opentypeforms={this.opentypeforms}
            deleteOnClick={this.deleteOnClick}
            handleSortingChange={this.handleSortingChange}
          />
        )}

        {this.state.isBankAdjustmentReasonEntryFormOpen && (
          <BankAdjustmentReasonEntryForm
            {...this.state}
            onChange={this.onChange}
          />
        )}
      </div>
    );
  }
}

function BankAdjustmentReasonAttributeModule(props) {
  return (
    <div id="moduleContainer" className="module_container">
      <div className="app">
        <BankAdjustmentReasonList {...props} name="" />
        <br />
      </div>
    </div>
  );
}
export default BankAdjustmentReasonAttributeModule;
